module.exports = __webpack_public_path__ + "media/img/illustrations/minus@1.5x-71f326c9dbec0a3adcab0a2b329d1c33.svg";